// Vuex transaction module actions
import { API } from '@/config';

export default {
  async sendFormData(commit, formData) {
    try {
      const response = await API.post('/form/sendEmail', formData );
      return response;
    } catch (err) {
      console.log(err);
    }
    return null;
  },

};
